import { CircularProgress } from '@mui/material';

import {
  PageLoaderContainer,
  PageLoaderWrapper,
  PageLoaderLogo,
  FirstRow,
  PageLoaderText,
} from './PageLoader.styles';

const PageLoader = ({ loadingText }: { loadingText?: string }) => (
  <PageLoaderContainer>
    <FirstRow>
      <PageLoaderLogo />
      <PageLoaderWrapper>
        <CircularProgress disableShrink color="primary" size="38px" />
      </PageLoaderWrapper>
    </FirstRow>
    {loadingText && <PageLoaderText>{loadingText}</PageLoaderText>}
  </PageLoaderContainer>
);

export default PageLoader;
